import { useQuery } from '@tanstack/react-query'
import { transcriptionApi } from '../../utils/api'

/**
 * TRPGシステム一覧（マスタ）の取得（UploadPage）。
 * 変化頻度が低いため staleTime を長めにする。
 */
export function useTrpgSystems() {
  return useQuery({
    queryKey: ['trpgSystems'],
    queryFn: () => transcriptionApi.getTRPGSystems(),
    staleTime: 5 * 60 * 1000,
  })
}
